<section class="icip-hero" id="hero" aria-label="Hero">
  <div class="icip-hero__bg" aria-hidden="true"></div>

  <div class="icip-hero__container">
    <div class="icip-hero__grid">
      <div class="icip-hero__left">
        <div class="icip-hero__badge">
          <span class="icip-hero__badge-dot" aria-hidden="true"></span>
          International Caller ID Platform
        </div>

        <h1 class="icip-hero__title">
          Global Branded Calling.
          <br />
          <span class="icip-hero__title-accent">Simplified.</span>
        </h1>

        <p class="icip-hero__subtitle">
          Manage international display names, carrier access, and reporting across multiple markets, all in one secure platform.
        </p>

        <div class="icip-hero__ctas">
          <button type="button" class="icip-hero__cta-primary" (click)="planPrompt.open()">
            <span class="icip-hero__cta-shimmer" aria-hidden="true"></span>
            <span class="icip-hero__cta-sweep" aria-hidden="true"></span>
            <span class="icip-hero__cta-content">
              Get Started
              <svg class="icip-hero__cta-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path d="M13 6L19 12L13 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
          </button>

          <a class="icip-hero__cta-secondary" href="#pricing" (click)="scrollToPricing($event)">
            View Plans
            <svg class="icip-hero__cta-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </a>
        </div>

        <div class="icip-hero__stats" aria-label="Key stats">
          <div class="icip-hero__stat">
            <div class="icip-hero__stat-value">14+</div>
            <div class="icip-hero__stat-label">Countries</div>
          </div>
          <div class="icip-hero__stat">
            <div class="icip-hero__stat-value">15+</div>
            <div class="icip-hero__stat-label">Carrier Networks</div>
          </div>
          <div class="icip-hero__stat">
            <div class="icip-hero__stat-value">300M+</div>
            <div class="icip-hero__stat-label">Monthly Calls</div>
          </div>
        </div>
      </div>

      <div class="icip-hero__right" aria-label="Phone mock">
        <div class="icip-mock">
          <div class="icip-mock__grid" aria-hidden="true"></div>
          <div class="icip-mock__glow icip-mock__glow--blue" aria-hidden="true"></div>
          <div class="icip-mock__glow icip-mock__glow--navy" aria-hidden="true"></div>

          <div
            class="icip-mock__pill"
            [style.background]="pillBg"
            [style.border]="'1px solid ' + pillBorder"
          >
            <span
              class="icip-mock__pill-dot"
              [class.is-blinking]="isRinging"
              [style.background]="dotColor"
              aria-hidden="true"
            ></span>
            <span class="icip-mock__pill-text" [style.color]="labelColor">{{ labelText }}</span>
          </div>

          <div class="icip-mock__phone" [class.is-ringing]="isRinging">
            <div class="icip-mock__pulse icip-mock__pulse--a" *ngIf="isRinging" aria-hidden="true"></div>
            <div class="icip-mock__pulse icip-mock__pulse--b" *ngIf="isRinging" aria-hidden="true"></div>

            <div class="icip-mock__phone-inner">
              <img class="icip-mock__img"
                srcset="assets/icip/phone-1-240.png 240w, assets/icip/phone-1-460.png 460w"
                sizes="(max-width: 600px) 200px, 230px"
                src="assets/icip/phone-1-460.png"
                alt="Unbranded incoming call"
                fetchpriority="high"
                width="460" height="805"
                [class.is-visible]="visibleImage === 'unknown'" />
              <img class="icip-mock__img"
                srcset="assets/icip/phone-2-240.png 240w, assets/icip/phone-2-460.png 460w"
                sizes="(max-width: 600px) 200px, 230px"
                src="assets/icip/phone-2-460.png"
                alt="INFORM incoming call"
                loading="lazy"
                width="460" height="690"
                [class.is-visible]="visibleImage === 'inform'" />
              <img class="icip-mock__img"
                srcset="assets/icip/phone-3-240.png 240w, assets/icip/phone-3-460.png 460w"
                sizes="(max-width: 600px) 200px, 230px"
                src="assets/icip/phone-3-460.png"
                alt="Branded incoming call"
                loading="lazy"
                width="460" height="861"
                [class.is-visible]="visibleImage === 'branded'" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="icip-hero__marquee">
      <p class="icip-hero__marquee-title">
        <span class="icip-hero__marquee-title-top">Trusted by leading carriers &amp; 15K+ enterprises</span>
        <br />
        <span class="icip-hero__marquee-title-bottom">worldwide.</span>
      </p>

      <div class="icip-hero__divider" aria-hidden="true"></div>

      <div class="icip-hero__logo-track" aria-label="Partner logos">
        <div class="icip-hero__logo-inner">
          <div class="icip-hero__logo-group">
            <div class="icip-hero__logo" aria-label="448 Connect">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698bb399c9e32f9a8caf89cf_448%20Connect%20Logo.svg" alt="448 Connect" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="448R">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698bbc35206145c4e901f167_448R%20Logo%20copy.svg" alt="448R" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Balboa Digital">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b8175be2cff58cde0e95a_balboa_digital.svg" alt="Balboa Digital" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Call Contact Center Compliance">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b77d2dd3dcb6ab1424919_call_contact_center_compliance_logo.svg" alt="Call Contact Center Compliance" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Dynamic Capital">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b84d4a874ec8e9b5da9c9_dynamic_capital_logo.svg" alt="Dynamic Capital" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Galileo">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b7b9a5079ac7c2698726a_galileo-logo.svg" alt="Galileo" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Glia">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/69fe32ad4cb1e12be3b91945_glia%20logo%20small.png" alt="Glia" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Intelisys">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698bac427b273d1164889831_Intelisys-Red-BlackText-2026.svg" alt="Intelisys" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Pacific Debt Relief">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698ba514e46730f54d8b1cc4_pacific_debt_relief.svg" alt="Pacific Debt Relief" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Pacific East">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698baa734390cf3ea3920ac2_logo-pacific-east.svg" alt="Pacific East" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Regal AI">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b81f2db9040f497730dc5_regal_ai_logo.svg" alt="Regal AI" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Telnyx">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/69b032d2d136a8264187f832_Logo.svg" alt="Telnyx" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Sundae">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b7c3482b7f60b34f85867_sundae.svg" alt="Sundae" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="T-Mobile">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b77cd32adfe30d1ae47c1_T-Mobile_2020.svg" alt="T-Mobile" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="USRC">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b77dee606206fbb43a0da_usrc-logo.svg" alt="USRC" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="DT">
              <img src="assets/images/dt-logo.png" alt="DT" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Vodafone">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/69b037fa5cc35304a3edb6eb_698bab49e96f6ee4e98bea5e_Vodafone_2017_logo.svg" alt="Vodafone" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Zofeur">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b7b49dd30c9bf93f1a3e1_zofeur.svg" alt="Zofeur" height="40" loading="lazy" />
            </div>
          </div>
          <div class="icip-hero__logo-group" aria-hidden="true">
            <div class="icip-hero__logo" aria-label="448 Connect">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698bb399c9e32f9a8caf89cf_448%20Connect%20Logo.svg" alt="448 Connect" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="448R">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698bbc35206145c4e901f167_448R%20Logo%20copy.svg" alt="448R" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Balboa Digital">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b8175be2cff58cde0e95a_balboa_digital.svg" alt="Balboa Digital" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Call Contact Center Compliance">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b77d2dd3dcb6ab1424919_call_contact_center_compliance_logo.svg" alt="Call Contact Center Compliance" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Dynamic Capital">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b84d4a874ec8e9b5da9c9_dynamic_capital_logo.svg" alt="Dynamic Capital" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Galileo">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b7b9a5079ac7c2698726a_galileo-logo.svg" alt="Galileo" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Glia">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/69fe32ad4cb1e12be3b91945_glia%20logo%20small.png" alt="Glia" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Intelisys">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698bac427b273d1164889831_Intelisys-Red-BlackText-2026.svg" alt="Intelisys" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Pacific Debt Relief">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698ba514e46730f54d8b1cc4_pacific_debt_relief.svg" alt="Pacific Debt Relief" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Pacific East">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698baa734390cf3ea3920ac2_logo-pacific-east.svg" alt="Pacific East" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Regal AI">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b81f2db9040f497730dc5_regal_ai_logo.svg" alt="Regal AI" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Telnyx">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/69b032d2d136a8264187f832_Logo.svg" alt="Telnyx" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Sundae">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b7c3482b7f60b34f85867_sundae.svg" alt="Sundae" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="T-Mobile">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b77cd32adfe30d1ae47c1_T-Mobile_2020.svg" alt="T-Mobile" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="USRC">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b77dee606206fbb43a0da_usrc-logo.svg" alt="USRC" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="DT">
              <img src="assets/images/dt-logo.png" alt="DT" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Vodafone">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/69b037fa5cc35304a3edb6eb_698bab49e96f6ee4e98bea5e_Vodafone_2017_logo.svg" alt="Vodafone" height="40" loading="lazy" />
            </div>
            <div class="icip-hero__logo" aria-label="Zofeur">
              <img src="https://cdn.prod.website-files.com/68cedfa9417cbdfcf0539958/698b7b49dd30c9bf93f1a3e1_zofeur.svg" alt="Zofeur" height="40" loading="lazy" />
            </div>
          </div>
        </div>
      </div>

      <div class="icip-hero__divider" aria-hidden="true"></div>
    </div>
  </div>
</section>
